import React from 'react';
import {PropTypes} from 'prop-types';
import {connect} from 'react-redux';
import DialogueTitle from 'components/DialogueTitle';
import DialogueButtons from 'components/DialogueButtons';
import Modal from 'react-modal';
import Resources from 'utilities/Resources';
import 'styles/exports.scss';

class EditTriggerErrorDialogue extends React.Component {
  static propTypes = {
    showDialogue: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  };

  close = () => {
    this.props.onClose();
  };

  render() {
    const resources = Resources.localizedString;
    return (
      <Modal
      className={"dialogue"}
      contentLabel="Update Trigger Modal"
      onRequestClose={this.onClose}
      onClose={this.onclose}
      isOpen={this.props.showDialogue}
      style={{
        content: {
          width: 950,
          height: 370
        }
      }}>
        <DialogueTitle title="Save Failed" />
        <div className="padded margin-vertical">
          <div className="padded margin-vertical text-center">
            <span className="status-icon status-icon--error margin-bottom"></span>
            <p className="margin-top">{resources.anErrorOccurredSavingTrigger}</p>
            <p>{resources.pleaseTryAgainInFewMinutes}</p>
          </div>
        </div>
        <DialogueButtons
          showCancelButton={false}
          confirmFunction={this.close}
          confirmButtonText={resources.ok} />
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  };
}
export {EditTriggerErrorDialogue as EditTriggerErrorDialogueNoRedux};

const ConnectedEditTriggerErrorDialogue = connect(mapStateToProps, mapDispatchToProps)(EditTriggerErrorDialogue);
export default ConnectedEditTriggerErrorDialogue;